import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Card, CardHeader } from "reactstrap";
import Button from "../../../../components/Button";
import { mergeTaskListConfigWithDefaults } from "../../../Home/Manager/TaskList/config";
import TaskList, { TASK_LIST_FORM_ID } from "./TaskList";
import { usePreferenceMutation } from "../api/usePreferenceMutation";
import { useCompanyPreferences } from "../hooks/usePreferences";
import Menu from "../components/Menu";

const WIDGET_TASK_LIST = "task-list";

// tab label -> key of the widget inside the dashboard configuration
const widgets = {
	[WIDGET_TASK_LIST]: {
		key: "taskList",
		getDefaults: () => {
			return mergeTaskListConfigWithDefaults();
		},
	},
};

function Dashboard() {
	const { t } = useTranslation();
	const [activeWidget, setActiveWidget] = useState(WIDGET_TASK_LIST);

    const { mutate, isPending } = usePreferenceMutation("company", "dashboard");
    const dashboardConfig = useCompanyPreferences("dashboard");

	const saveWidget = useCallback((widget, config) => {
		return mutate({ ...dashboardConfig, [widgets[widget].key]: config });
	}, [dashboardConfig, mutate]);

	const onSaveTaskList = useCallback((config) => {
		return saveWidget(WIDGET_TASK_LIST, config);
	}, [saveWidget]);

	const onReset = useCallback(async () => {
		try {
			await saveWidget(activeWidget, widgets[activeWidget].getDefaults());
			toast.success(t("preferences-saved-successfully"));
		} catch {
			toast.error(t("error-saving-preferences"));
		}
	}, [activeWidget, saveWidget, t]);

	return (
		<Card className="h-100">
			<CardHeader className="d-flex align-items-center justify-content-between">
				<h3 className="mb-0">{t("dashboard")}</h3>
				<div className="d-flex align-items-center gap-2">
					<Button
						className="btn-outline-dark px-3 btn-round btn-icon"
						size="sm"
						disabled={isPending}
						type="button"
						onClick={onReset}
					>
						{t("reset")}
					</Button>
					<Button
						className="btn-dark px-3 btn-round btn-icon"
						size="sm"
						loading={isPending}
						disabled={isPending}
						type="submit"
						form={TASK_LIST_FORM_ID}
					>
						{t("save")}
					</Button>
				</div>
			</CardHeader>
			<div>
				{/* <Topbar options={Object.keys(widgets)} menu={activeWidget} setMenu={setActiveWidget} /> */}
                <Menu
                    options={Object.keys(widgets)}
                    option={activeWidget}
                    setOption={setActiveWidget}
                />
				{activeWidget === WIDGET_TASK_LIST && <TaskList onSave={onSaveTaskList} />}
			</div>
		</Card>
	);
}

export default Dashboard;
